"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useSticky = function useSticky(element) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0],
    setIsSticky = _useState2[1];
  (0, _react.useEffect)(function () {
    var scrollHandler = function scrollHandler() {
      var bounding = element.current.getBoundingClientRect();
      var isStickyNow = bounding.top < 0 && bounding.bottom > 0;
      setIsSticky(isStickyNow);
    };
    window.addEventListener('scroll', scrollHandler);
    return function () {
      return window.removeEventListener('scroll', scrollHandler);
    };
  }, []);
  return {
    isSticky: isSticky
  };
};
var StickyHeader = function StickyHeader(props) {
  var header = props.header,
    table = props.table;
  var ref = (0, _react.useRef)();
  var headerRef = (0, _react.useRef)();
  var wrapperRef = (0, _react.useRef)();
  var _useSticky = useSticky(ref),
    isSticky = _useSticky.isSticky;
  (0, _react.useEffect)(function () {
    var scrollWrapper = ref.current.closest('[data-table-scroll-wrapper]');
    if (!scrollWrapper) {
      return;
    }
    wrapperRef.current = scrollWrapper;
    var handleWrapperScroll = function handleWrapperScroll() {
      if (!wrapperRef.current || !headerRef.current) {
        return;
      }
      headerRef.current.scrollLeft = wrapperRef.current.scrollLeft;
    };
    wrapperRef.current.addEventListener('scroll', handleWrapperScroll);
    return function () {
      return wrapperRef.current.removeEventListener('scroll', handleWrapperScroll);
    };
  }, []);

  // duplicate dimensions for the header
  (0, _react.useEffect)(function () {
    if (!isSticky || !ref.current || !headerRef.current) {
      return;
    }
    var columns = ref.current.querySelectorAll('thead tr:first-child th');
    var widths = [];
    var _iterator = _createForOfIteratorHelper(columns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var column = _step.value;
        widths.push(column.getBoundingClientRect().width);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var theadColumns = headerRef.current.querySelectorAll('thead tr:first-child th');
    var _iterator2 = _createForOfIteratorHelper(theadColumns),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _column = _step2.value;
        if (widths.length === 0) {
          break;
        }
        _column.style.minWidth = "".concat(widths.shift(), "px");
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (wrapperRef.current) {
      var bounding = wrapperRef.current.getBoundingClientRect();
      headerRef.current.style.left = "".concat(bounding.left, "px");
      headerRef.current.style.width = "".concat(bounding.width, "px");
    }
  });
  (0, _react.useEffect)(function () {
    if (isSticky && wrapperRef.current && headerRef.current) {
      headerRef.current.scrollLeft = wrapperRef.current.scrollLeft;
    }
  }, [isSticky]);
  var handleHeaderScroll = function handleHeaderScroll() {
    if (!wrapperRef.current || !headerRef.current) {
      return;
    }
    wrapperRef.current.scrollLeft = headerRef.current.scrollLeft;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSticky && /*#__PURE__*/_react["default"].createElement("div", {
    ref: headerRef,
    className: _style["default"].sticky,
    onScroll: handleHeaderScroll
  }, header), /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, table));
};
StickyHeader.propTypes = {
  header: _propTypes["default"].node,
  table: _propTypes["default"].node
};
var _default = exports["default"] = StickyHeader;